import { useContext, type ReactNode, type Ref } from "react";
import { BentoVisit, type BentoVisitHost } from "@/components/ui/box-visit-context";
import { Button } from "@/components/ui/button";

/**
 * The visit to the attempt's amendment, read where it draws: a visit's boxes are resolved
 * outside the host's provider, so the host is the one around the drawn Bento (O10).
 */
export function AmendVisit({ to, from, button, children }: { to: Parameters<BentoVisitHost["visit"]>[0]; from: string; button: Ref<HTMLButtonElement>; children: ReactNode }) {
  const host = useContext(BentoVisit);
  return host ? <Button ref={button} type="button" variant="outline" size="sm" className="justify-self-start" data-act="visit" data-visit-to={to}
    onClick={() => host.visit(to, { box: from })}>{children}</Button> : null;
}
